import { render, staticRenderFns } from "./taxExemptTag.vue?vue&type=template&id=4067da55"
import script from "./taxExemptTag.vue?vue&type=script&lang=js"
export * from "./taxExemptTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports